import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const TypPneu = {
	name: NAME,
	apiProvider,
	router,
};
